"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useOtpV2 = (error) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        '& input': {
            fontSize: '1.5rem',
            height: '56px !important',
            width: '56px !important',
            border: error ? `solid 2px ${theme.qlub.palette.danger.main}` : 'solid 2px #F3F3F3',
            borderRadius: 2,
        },
        '& input:focus-visible': {
            outline: 'none',
            border: error ? `solid 2px ${theme.qlub.palette.danger.main}` : `solid 2px ${theme.qlub.palette.iris.main}`,
            borderRadius: 2,
        },
        '& > div': {
            'html[dir="rtl"] &': {
                flexDirection: 'row-reverse',
                justifyContent: 'flex-end',
            },
        },
    };
    return {
        container,
    };
};
exports.default = useOtpV2;
